export default "__VITE_ASSET__Byp1KRGO__"